export const billingEmailType = 2;
export const contactEmailType = 3;



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/customers/customer-constants.js
 **/